export default "__VITE_ASSET__DDw_fKc0__"